// extracted by mini-css-extract-plugin
export var divider = "_p4-0";
export var systemMessage = "_p4-1";
export var systemMessageWrapper = "_p4-2";